import {EnvironmentProviders, Injectable, makeEnvironmentProviders} from "@angular/core";

import {StockageLangueUtilisateur, VAL_STOCKAGE_LANGUE_UTILISATEUR} from "../../../../val-definitions-communes-lib/src/public-api";
import {ServicesPreferencesService} from "./val-services-preferences.service";

//Code de la préférence de langue de l’interface, commune à toutes les applications
export const codePreferenceLangue = "plateforme.langue";

//Valeur de la préférence de langue
export interface PreferenceLangue
{
  langue: string;
}

//Stockage de la langue de l’utilisateur dans ses préférences Ammon Services : la langue choisie
//le suit d’un poste et d’un navigateur à l’autre
@Injectable (
{
  providedIn: 'root'
})
export class ServicesLangueUtilisateurService implements StockageLangueUtilisateur
{
  //Création
  //  Paramètres
  //    servicesPreferencesService : Service des préférences de l’utilisateur
  constructor (private servicesPreferencesService: ServicesPreferencesService)
  {
  }

  //Retourne la langue enregistrée pour l’utilisateur, null s’il n’en a pas
  //  Retourne
  //    Code de la langue. Lève une erreur si l’API ne répond pas ou refuse
  public async Lire () : Promise<string | null>
  {
    const valApiResultat = await this.servicesPreferencesService.RetournerPreferences<PreferenceLangue> (codePreferenceLangue);

    if (valApiResultat?.status !== "success")
      throw new Error (valApiResultat?.message ?? "");

    const langue: unknown = valApiResultat.resultat?.find (preference => preference.code === codePreferenceLangue)?.valeur?.langue;

    return typeof langue === "string" && langue !== "" ? langue : null;
  }

  //Enregistre la langue choisie par l’utilisateur
  //  Paramètres
  //    langue : Code de la langue
  //  Retourne
  //    Opération asynchrone. Lève une erreur si l’API ne répond pas ou refuse
  public async Enregistrer (langue: string) : Promise<void>
  {
    const valApiResultat = await this.servicesPreferencesService.EnregistrerPreference<PreferenceLangue> (codePreferenceLangue, {langue: langue});

    if (valApiResultat?.status !== "success")
      throw new Error (valApiResultat?.message ?? "");
  }
}

//Fournit le stockage de la langue de l’utilisateur dans ses préférences Ammon Services.
//À poser dans la configuration d’une application : sans lui, la langue reste mémorisée par navigateur
export function provideLangueUtilisateur () : EnvironmentProviders
{
  return makeEnvironmentProviders ([{provide: VAL_STOCKAGE_LANGUE_UTILISATEUR, useExisting: ServicesLangueUtilisateurService}]);
}
